"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintfError = exports.TypeMismatch = exports.InvalidNumberOfArguments = exports.UnassignedVariable = exports.InvalidTypeError = exports.StackOverflowError = exports.UndefinedVariable = exports.CallingNonFunctionValue = exports.ExceptionError = void 0;
/* tslint:disable: max-classes-per-file */
/* tslint:disable:max-line-length */
const astring_1 = require("astring");
const types_1 = require("../types");
const runtimeSourceError_1 = require("./runtimeSourceError");
class ExceptionError {
    constructor(error, location) {
        this.error = error;
        this.location = location;
        this.type = types_1.ErrorType.RUNTIME;
        this.severity = types_1.ErrorSeverity.ERROR;
    }
    explain() {
        return this.error.toString();
    }
    elaborate() {
        return 'TODO';
    }
}
exports.ExceptionError = ExceptionError;
class CallingNonFunctionValue extends runtimeSourceError_1.RuntimeSourceError {
    constructor(callee, command) {
        super(command);
        this.callee = callee;
        this.command = command;
    }
    explain() {
        return `Calling non-function value`;
    }
    elaborate() {
        return '';
    }
}
exports.CallingNonFunctionValue = CallingNonFunctionValue;
class UndefinedVariable extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Name ${this.name} not declared.`;
    }
    elaborate() {
        return `Before you can read the value of ${this.name}, you need to declare it as a variable or a constant. You can do this using the let or const keywords.`;
    }
}
exports.UndefinedVariable = UndefinedVariable;
class StackOverflowError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Stack memory is fully utilized`;
    }
    elaborate() {
        return `Stack memory is fully utilized. Consider increasing the stack size.`;
    }
}
exports.StackOverflowError = StackOverflowError;
class InvalidTypeError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Invalid type error!`;
    }
    elaborate() {
        return `Invalid type error!.`;
    }
}
exports.InvalidTypeError = InvalidTypeError;
class UnassignedVariable extends runtimeSourceError_1.RuntimeSourceError {
    constructor(name, node) {
        super(node);
        this.name = name;
    }
    explain() {
        return `Name ${this.name} declared later in current scope but not yet assigned`;
    }
    elaborate() {
        return `If you're trying to access the value of ${this.name} from an outer scope, please rename the inner ${this.name}. An easy way to avoid this issue in future would be to avoid declaring any variables or constants with the name ${this.name} in the same scope.`;
    }
}
exports.UnassignedVariable = UnassignedVariable;
class InvalidNumberOfArguments extends runtimeSourceError_1.RuntimeSourceError {
    constructor(command, expected, got, hasVarArgs = false) {
        super(command);
        this.expected = expected;
        this.got = got;
        this.hasVarArgs = hasVarArgs;
        this.calleeStr = (0, astring_1.generate)(command.callee);
    }
    explain() {
        return `Expected ${this.expected} ${this.hasVarArgs ? 'or more ' : ''}arguments, but got ${this.got}.`;
    }
    elaborate() {
        const calleeStr = this.calleeStr;
        const pluralS = this.expected === 1 ? '' : 's';
        return `Try calling function ${calleeStr} again, but with ${this.expected} argument${pluralS} instead. Remember that arguments are separated by a ',' (comma).`;
    }
}
exports.InvalidNumberOfArguments = InvalidNumberOfArguments;
class TypeMismatch extends runtimeSourceError_1.RuntimeSourceError {
    constructor(command, expected, got) {
        super(command);
        this.expected = expected;
        this.got = got;
    }
    explain() {
        if (this.got == undefined) {
            return `Unable to detect type, please specify a primitive type: int, float, void or char.`;
        }
        return `Expected ${this.expected.valueType} but got ${this.got}`;
    }
    elaborate() {
        return `Ensure that the types are the same.`;
    }
}
exports.TypeMismatch = TypeMismatch;
class PrintfError extends runtimeSourceError_1.RuntimeSourceError {
    constructor() {
        super();
    }
    explain() {
        return `Argument mismatched detected. Is it possible that you passed a string as a parameter?`;
    }
    elaborate() {
        return `Strings as arguments other than the first is currently not supported.`;
    }
}
exports.PrintfError = PrintfError;
//# sourceMappingURL=errors.js.map